import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_INVOICE_DOCUMENT_PROVIDER_RESET = 'POST_INVOICE_DOCUMENT_PROVIDER_RESET';
export const POST_INVOICE_DOCUMENT_PROVIDER_LOADING = 'POST_INVOICE_DOCUMENT_PROVIDER_LOADING';
export const POST_INVOICE_DOCUMENT_PROVIDER_SUCCESS = 'POST_INVOICE_DOCUMENT_PROVIDER_SUCCESS';
export const POST_INVOICE_DOCUMENT_PROVIDER_REJECT = 'POST_INVOICE_DOCUMENT_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postInvoiceDocumentProviderReset = () => ({ type: POST_INVOICE_DOCUMENT_PROVIDER_RESET });
export const postInvoiceDocumentProviderLoading = () => ({ type: POST_INVOICE_DOCUMENT_PROVIDER_LOADING });
export const postInvoiceDocumentProviderSuccess = (payload) => ({ type: POST_INVOICE_DOCUMENT_PROVIDER_SUCCESS, payload });
export const postInvoiceDocumentProviderReject = (payload) => ({ type: POST_INVOICE_DOCUMENT_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postInvoiceDocumentProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data: { routes: data.routes },
    }, getState);
    return request(`/ProvidersBillingTracking/web/AddClientesBillingImport?ProvidersTranckingId=${data.id}`, options);
};